export default __webpack_public_path__ + "static/media/calendar_tab_icon.59433703.svg";